import { ReactElement, useEffect } from 'react';
import { tile } from '@interfaces/interfaces';
import { Field, useFormikContext } from 'formik';
import { TileRadioAccessible, CheckboxInputAccessible, Alert } from '@components';
import gridStyles from '@pages/forms/Grid.module.scss';
import { iReviewFormValues } from '@services/ReviewService';
import styles from './ReviewStep5.module.scss';
import InfoIcon from '../../../../images/info.svg';

function ReviewStep5(): ReactElement {
  const { values }: { values: iReviewFormValues; } = useFormikContext<iReviewFormValues>();
  const formikContext = useFormikContext();
  const YesValue = (): ReactElement => (
    <>
      <div>I am the person named on the fine</div>
    </>
  );

  const NoValue = (): ReactElement => (
    <>
      <div>I am authorised to act on behalf of the person named on the fine</div>
    </>
  );

  const TILE_DATA: tile[] = [
    {
      body: <YesValue />,
      value: 'true',
    },
    {
      body: <NoValue />,
      value: 'false',
    },
  ];

  const ReviewStep5InfoContainerContent = (
    <div>
      <div>
        Some examples of people that may act on behalf of the person who received the fine are:
        <br />
        <ul className={styles.listwithoutPadding}>
          <li>their lawyer or attorney</li>
          <li>their company representative</li>
          <li>their power of attorney</li>
          <li>
            the person they have given an ‘Authority to Act’ in their
            {' '}
            <a href="/Support/Authorise-another-person-to-help-manage-your-fines" target="_blank" rel="noopener noreferrer">
              Third Party Authorisation
            </a>
            {' '}
            with Fines Victoria
          </li>
          <li>their guardian</li>
          <li>their VCAT appointed administrator</li>
        </ul>
        <span>
          When completing this application, you will need to provide your own details, as well as the details for the person who received the fine.
        </span>
        <br />
        {' '}
      </div>
    </div>
  );
  useEffect(() => {
    if (values.isThePersonNamed === 'true') {
      formikContext.setFieldValue('isThirdPartyAuthorised', false);
      formikContext.setFieldTouched('isThirdPartyAuthorised', false);
    }
  }, [values.isThePersonNamed]);
  return (
    <>
      <div className={gridStyles.form}>
        <span className="vfH2">Which statement best describes you?</span>
        <div className={gridStyles.gridColFull}>
          <div className={styles.col}>
            <Field
              name="isThePersonNamed"
              title=""
              component={TileRadioAccessible}
              tileData={TILE_DATA}
              orientationColumn
              isMandatory
              classname={styles.tile}
            />
            {values.isThePersonNamed === 'false' && (
              <>
                <Field
                  name="isThirdPartyAuthorised"
                  component={CheckboxInputAccessible}
                  title="The person who received the fine has authorised you to act on their behalf."
                  // boxChecked={(e: boolean) => {
                  //   values.isThirdPartyAuthorised = e;
                  // }}
                />
                <Alert
                  message={ReviewStep5InfoContainerContent}
                  icon={InfoIcon}
                  theme="info"
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ReviewStep5;
